import { render } from "./registrationStep6.vue?vue&type=template&id=8fbd30d6&scoped=true"
import script from "./registrationStep6.vue?vue&type=script&lang=js"
export * from "./registrationStep6.vue?vue&type=script&lang=js"

import "./registrationStep6.vue?vue&type=style&index=0&id=8fbd30d6&lang=scss&scoped=true"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-8fbd30d6"]])

export default __exports__